<div class="data-panel w-full relative overflow-hidden my-[36px] pb-[26px] px-[34px]">
  <div class="flex justify-between items-center mt-[24px]">
    <div class="font-termina text-[20px] lg:text-[24px]">
      Scheduled Questionnaires
    </div>
    <div class="flex justify-center">
      <button
        (click)="openCreateScheduledQuestionnaireModal()"
        matRipple
        class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors"
        >
        Schedule Questionnaire
      </button>
    </div>
  </div>
  <div class="h-[1px] w-full bg-inverted-neutral opacity-40 my-[20px]"></div>

  @if (surveyRespondentQuestionnairesPaginated) {
    <div>
      <div class="rounded-[10px] border border-textbox-border p-[20px] mb-[36px]">
        <div class="w-full flex flex-col">
          <div class="text-left inter-500 text-[14px] flex h-[31px] mb-[14px] text-support-text">
            <div
              (click)="sortResults('questionnaireName')"
              (keydown.enter)="sortResults('questionnaireName')"
              (keydown.space)="sortResults('questionnaireName'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Questionnaire', 'questionnaireName')"
              class="w-[400px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Questionnaire</span>
              @if (sortKey === 'questionnaireName') {
                <span class="ml-2">
                  <span [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'" class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200" aria-hidden="true">arrow_upward</span>
                </span>
              }
            </div>
            <div class="w-[1px] bg-inverted-neutral opacity-40 rounded-full"></div>
            <div
              (click)="sortResults('dispatchOn')"
              (keydown.enter)="sortResults('dispatchOn')"
              (keydown.space)="sortResults('dispatchOn'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Dispatch Date', 'dispatchOn')"
              class="w-[200px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Dispatch Date</span>
              @if (sortKey === 'dispatchOn') {
                <span class="ml-2">
                  <span [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'" class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200" aria-hidden="true">arrow_upward</span>
                </span>
              }
            </div>
            <div class="w-[1px] bg-inverted-neutral opacity-40 rounded-full"></div>
            <div
              (click)="sortResults('recipient')"
              (keydown.enter)="sortResults('recipient')"
              (keydown.space)="sortResults('recipient'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Recipient', 'recipient')"
              class="w-[200px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Recipient</span>
              @if (sortKey === 'recipient') {
                <span class="ml-2">
                  <span [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'" class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200" aria-hidden="true">arrow_upward</span>
                </span>
              }
            </div>
          </div>
          <div class="h-[1px] bg-inverted-neutral opacity-40 mb-[14px]"></div>
          @for (scheduledQuestionnaire of surveyRespondentQuestionnairesPaginated.records; track scheduledQuestionnaire) {
            <div class="inter-300 text-[14px] text-support-text py-[13px] flex rounded-[6px] transition-colors duration-150 ease-out hover:bg-textbox-fill">
              <div class="w-[400px] pl-[20px] flex items-center break-all">{{ scheduledQuestionnaire.questionnaireName }}</div>
              <div class="w-[200px] pl-[30px] flex items-center">{{ scheduledQuestionnaire.dispatchOn | date: 'dd/MM/yyyy' }}</div>
              <div class="w-[200px] pl-[30px] flex items-center truncate">{{ scheduledQuestionnaire.recipient }}</div>
            </div>
          }
        </div>
      </div>
      <div class="flex justify-end">
        <app-paginator
          [pageSize]="surveyRespondentQuestionnairesPaginated.pageSize"
          [pageNumber]="surveyRespondentQuestionnairesPaginated.pageNumber"
          [totalRecords]="surveyRespondentQuestionnairesPaginated.totalRecords"
          (pageChanged)="changePage($event)"
          />
        </div>
      </div>
    }
  </div>
